// Único badge de estado de DESPACHO de remito/NE. Pinta el objeto estado_vigente
// que ya manda el backend (EstadoDespachoService → EstadoVigente VO):
//   { codigo, etiqueta, color, bg, accionable }
// NO deriva nada: el front muestra exactamente lo que mandó la única fuente de
// verdad. Ver docs/auditoria-estados-entrega.md ("Contrato").
//
// Mismo tamaño/forma que EstadoBadgeRemito (11px uppercase, pill chico).

const FALLBACK = { etiqueta: '—', color: '#64748b', bg: '#f1f5f9' }

export default function EstadoVigenteBadge({ estadoVigente }) {
  const ev = estadoVigente || FALLBACK
  const etiqueta = ev.etiqueta ?? ev.codigo ?? FALLBACK.etiqueta
  const color = ev.color || FALLBACK.color
  const bg = ev.bg || FALLBACK.bg
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: 4,
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: '0.02em',
      textTransform: 'uppercase',
      background: bg,
      color,
    }}>
      {etiqueta}
    </span>
  )
}
